export default function EnableFocusOnElementsOnTabNavigationFix() {
	let mouseClickFlag = false;
	//Set the flag when a mousedown event occurs (for any element)
	document.addEventListener('mousedown', () => {
		mouseClickFlag = true;
	}, true);

	// Reset the flag after a short delay to ensure it doesn't interfere with subsequent focus events
	document.addEventListener('focusin', (event) => {
		const focusedElement = event.target;
		if (mouseClickFlag) {
			mouseClickFlag = false;
			return; // Exit the function to prevent scrolling
		}

		// Get the bounding rectangle of the focused element
		const rect = focusedElement.getBoundingClientRect();
		// Get elements from the center in four directions
		const topElement = document.elementFromPoint(rect.left, rect.top); // Up
		// Check if the focused element is not the same as the topElement or its descendant
		if (!(focusedElement.isSameNode(topElement) || focusedElement.contains(topElement))) {
			focusedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	}, true);
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/navigation/controllers/enable_focus_on_elements_on_tab_navigation.js